// @tiptap/core, @tiptap/pm y @tiptap/extension-placeholder no son dependencias nuevas: son
// dependencias directas de ra-input-rich-text y se importan aquí para usar la misma instancia
// que su RichTextInput.
import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Slice } from '@tiptap/pm/model';

/**
 * Corta un fragmento pegado para que no aporte más de `max` caracteres de texto.
 */
const truncateSlice = (slice, max) => {
    if (slice.content.textBetween(0, slice.content.size, '', '').length <= max) return slice;
    if (max <= 0) return Slice.empty;

    let remaining = max;
    let cutAt = null;
    slice.content.descendants((node, pos) => {
        if (cutAt !== null) return false;
        if (!node.isText) return true;
        if (node.text.length >= remaining) {
            cutAt = pos + remaining;
            return false;
        }
        remaining -= node.text.length;
        return false;
    });

    return Slice.maxOpen(slice.content.cut(0, cutAt ?? slice.content.size));
};

/**
 * Límite duro de caracteres visibles en el editor (texto sin etiquetas, lo mismo que cuenta el
 * contador y la validación): no deja teclear más y recorta lo que se pegue.
 *
 * Los cambios que no vienen del usuario —el `setContent` con el que RichTextInput carga el valor
 * del formulario, marcado con `preventUpdate`— pasan siempre, para no dejar en blanco un registro
 * que ya traiga más texto del permitido.
 */
export const MaxVisibleLength = Extension.create({
    name: 'maxVisibleLength',

    addOptions() {
        return { limit: 400 };
    },

    addProseMirrorPlugins() {
        const { limit } = this.options;
        const length = (doc) => doc.textContent.length;

        return [
            new Plugin({
                key: new PluginKey('maxVisibleLength'),
                filterTransaction: (transaction, state) => {
                    if (!transaction.docChanged || transaction.getMeta('preventUpdate')) return true;
                    const next = length(transaction.doc);
                    // Si ya se estaba por encima (texto cargado), se permite todo lo que no lo alargue.
                    return next <= limit || next <= length(state.doc);
                },
                props: {
                    transformPasted: (slice, view) => {
                        const { from, to } = view.state.selection;
                        const selected = view.state.doc.textBetween(from, to, '', '').length;
                        return truncateSlice(slice, limit - (length(view.state.doc) - selected));
                    },
                },
            }),
        ];
    },
});
